import { render, staticRenderFns } from "./SingleBenefit.vue?vue&type=template&id=1884685b"
import script from "./SingleBenefit.vue?vue&type=script&lang=js"
export * from "./SingleBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports